import { HamburgerButtonComponenta } from "./hamburgerMenuList/hamburgerButton";
import { SearchButtonComponenta } from "./searchInput/openSearchButton";
import { MenuListComponenta, HamburgerMenuItems } from "./hamburgerMenuList/menuList"
import { CalcalistSearchComponenta } from "./searchInput/searchArea";

require('././hamburgerMenuList/ctech_calcalist_site_menu.less')
require('./searchInput/ctech_calcalist_site_search_area.less')
interface HamburgerProps {
    menuItems: HamburgerMenuItems[]
    menuGroup1: HamburgerMenuItems[]
    menuGroup2: HamburgerMenuItems[]
    menuGroup3: HamburgerMenuItems[]
    menuGroup4: HamburgerMenuItems[]
    menuGroup5: HamburgerMenuItems[]
    width: number
    domain:string
    headerNewDesign?: boolean
}

interface HamburgerState {
    isOpenedHam: boolean
    isOpenedSearch: boolean
}
export class LeftSideMenuComponenta extends React.Component<HamburgerProps, HamburgerState> {
    public static siteScriptName = "LeftSideMenuComponenta"
    private searchAreaRef: HTMLDivElement = null

    constructor(props) {
        super(props)
        this.state = {
            isOpenedHam: false,
            isOpenedSearch: false
        }
    }

    componentDidUpdate(_prevProps, prevState: HamburgerState) {
        if (!this.props.headerNewDesign) {
            return
        }
        if (this.state.isOpenedSearch && !prevState.isOpenedSearch) {
            document.addEventListener("mousedown", this.handleOutsideSearchClick)
        } else if (!this.state.isOpenedSearch && prevState.isOpenedSearch) {
            document.removeEventListener("mousedown", this.handleOutsideSearchClick)
        }
    }

    componentWillUnmount() {
        if (this.props.headerNewDesign) {
            document.removeEventListener("mousedown", this.handleOutsideSearchClick)
        }
    }

    private onToggleHam = () => {
        this.setState({ isOpenedHam: !this.state.isOpenedHam, isOpenedSearch: false })
    }
    private onToggleSearch = () => {
        this.setState({ isOpenedSearch: !this.state.isOpenedSearch, isOpenedHam: false })
    }
    private handleOutsideSearchClick = (e: MouseEvent) => {
        if (!this.props.headerNewDesign) {
            return
        }
        if (!this.searchAreaRef || this.searchAreaRef.contains(e.target as Node)) {
            return
        }
        this.setState({ isOpenedSearch: false })
    }
    private clickAcessibilityBtn = () => {
        window[`EquallyAI`] && window[`EquallyAI`].openToolbox();
        window[`interdeal`] && window[`interdeal`][`a11y`] && window[`interdeal`][`a11y`].openMenu();
    }
    render() {
        const { headerNewDesign, menuItems, menuGroup1, menuGroup2, menuGroup3, menuGroup4, menuGroup5, width, domain } = this.props
        const { isOpenedSearch } = this.state
        return (

            <div className="LeftSideMenu no-print">
                {headerNewDesign ?
                <div className="leftSideMenu-container">
                     {isOpenedSearch ? (
                        <div ref={el => this.searchAreaRef = el}>
                            <CalcalistSearchComponenta width={width} domain={domain} headerNewDesign={true} />
                        </div>
                     ) : (
                        <SearchButtonComponenta onToggleSearch={this.onToggleSearch} isOpened={false} />
                     )}

                     <button className="accessibility-icon-new" onClick={this.clickAcessibilityBtn} id="INDmenu-btn-fixed" title="אתר נגיש" aria-labelledby="INDbtnTooltip" accessKey="m"></button>
                </div>
                :
                <SearchButtonComponenta onToggleSearch={this.onToggleSearch} isOpened={this.state.isOpenedSearch} />
                }
                <HamburgerButtonComponenta onToggleMenu={this.onToggleHam} isOpened={this.state.isOpenedHam} />
                <MenuListComponenta menuItems={menuItems} menuGroup1={menuGroup1} menuGroup2={menuGroup2} menuGroup3={menuGroup3} menuGroup4={menuGroup4} menuGroup5={menuGroup5} width={width} isOpenedHam={this.state.isOpenedHam} />
                {!headerNewDesign && this.state.isOpenedSearch && <CalcalistSearchComponenta width={width} domain={domain} />}
            </div>




        )


    }
}
